module.exports = __webpack_public_path__ + "img/main_slither1_up.47ecc816.png";